import React, { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";

export default function useNotificationsSearchInput({ filters, setFilter }) {
  const FILTER_NAME = "searchQuery";

  const [value, setValue] = useState(filters[FILTER_NAME].value);

  const handleChange = useCallback(
    value => {
      setValue(value);
    },
    [setValue]
  );

  const debouncedSearch = React.useMemo(
    () =>
      debounce(value => {
        setFilter(FILTER_NAME, value);
      }, 250),
    [setFilter]
  );

  useEffect(() => {
    const filterValue = filters[FILTER_NAME].value;

    if (filterValue === value) {
      return;
    }

    debouncedSearch(value);
  }, [value]);

  return [value, handleChange];
}
